import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { baristaFeedbacksGetRequest } from '../../store/baristaFeedbacks/actions'
import { useBaristaFeedbacksSelector } from '../../store/selectors'
const initialState = { employee: null, feedbacks: [], fetching: false }

const useEmployeeFeedbacksModal = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { items, fetching } = useBaristaFeedbacksSelector()
  const [state, _setState] = useState(initialState)
  const setState = useCallback((state) => setState((prev) => ({ ...prev, ...state })), [])
  const handleCloseModal = useCallback(() => _setState(initialState), [])

  const handleOpenEmployeeFeedbacksModal = useCallback((employee) => () => {
    if (employee.rating > 0) _setState({ employee })
  }, [])

  const handleGetFeedbacks = useCallback(() => {
    if (state.employee) dispatch(baristaFeedbacksGetRequest({ baristaId: state.employee.id }))
  }, [state.employee?.id])

  const employeeFeedbacksModalProps = {
    title: t('userFeedbacksModal:employeeReviews'),
    onGetFeedbacks: handleGetFeedbacks,
    onClose: handleCloseModal,
    avatarUrl: state.employee?.avatarUrl,
    fullName: state.employee?.fullName,
    rating: state.employee?.rating,
    isShown: !!state.employee,
    feedbacks: items,
    fetching,
  }

  return {
    initialized: !!state.employee,
    onOpen: handleOpenEmployeeFeedbacksModal,
    modalProps: employeeFeedbacksModalProps
  }
}

export default useEmployeeFeedbacksModal
